import { track } from '../analytics/analytics';
import { INSTANT_CHECKOUT_PAGINATION } from '../constants/analytics';

export interface IPaginationOutput {
  target: HTMLInputElement;
  value: number;
  overlayName: string;
  currentPage: number;
}

export const setPaginationAnalytics = (output: IPaginationOutput) => {
  const { target, value, overlayName, currentPage } = output;

  if (target.value) {
    track(INSTANT_CHECKOUT_PAGINATION, {
      overlayName: `select ${overlayName}`,
      action: 'select page',
      pageNumber: value,
    });
  } else if (currentPage - value === -1) {
    track(INSTANT_CHECKOUT_PAGINATION, {
      overlayName: `select ${overlayName}`,
      action: 'next page',
      pageNumber: value,
    });
  } else if (currentPage - value === 1) {
    track(INSTANT_CHECKOUT_PAGINATION, {
      overlayName: `select ${overlayName}`,
      action: 'previous page',
      pageNumber: value,
    });
  }
};
